<template>
  <div class="select-type">
    <div class="box">
      <h3>Choose type(user or photographer)</h3>
      <form>
        <div class="input-box">
          <input-radio
            class="input-radio"
            v-on:model="v => (form.type = v)"
            name="type"
            value="user"
            text="User"
            :required="true"
          ></input-radio>
          <input-radio
            class="input-radio"
            v-on:model="v => (form.type = v)"
            name="type"
            value="photographer"
            text="Photographer"
            :required="true"
          ></input-radio>
        </div>
        <input-button
          class="input-button"
          text="SELECT"
          :callFn="submit"
        ></input-button>
      </form>
    </div>
  </div>
</template>

<script>
import { InputRadio, InputButton } from './form-elemnets'
import * as types from '../../store/mutation-types'

export default {
  name: 'select-type',
  props: {
    propData: {
      default: new Object(),
      type: Object
    }
  },
  components: {
    InputRadio,
    InputButton
  },
  data() {
    return {
      form: {
        type: ''
      }
    }
  },
  updated() {
    console.log(this.form.type)
  },
  methods: {
    submit(event) {
      event.preventDefault()
      if (this.form.type === 'user' || this.form.type === 'photographer') {
        this.propData.user.type = this.form.type
        this.$store
          .dispatch(types.SET_SIGNUP, {
            user: this.propData.user,
            uid: this.propData.uid
          })
          .then(() => {
            // 여기에서 다시 가져오는 이유는 유저의 타입을 가져 오기 위함이다.
            this.$store
              .dispatch(types.GET_USERINFO, { uid: this.propData.uid })
              .then(this.goToMain)
          })
      } else {
        alert('You have to choose a photographer or user.')
      }
    },
    goToMain() {
      this.$store
        .dispatch(types.SET_MODAL_COMPONENT, {
          component: '',
          active: false,
          type: 'full'
        })
        .then(() => {
          this.$router.push({ path: '/main' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-type {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  height: 480px;
  width: 400px;

  .box {
    position: relative;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid gray;
    height: 480px;
    width: 400px;
    form {
      .input-box {
        display: flex;
      }
    }
  }
}
</style>
